// Angular
import { Component, OnInit } from '@angular/core';
// Models

import { Tournament } from './../../models/tournament';
// Services
import { AngularFireDatabase } from 'angularfire2/database';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { ApiService } from './../../services/api';
import * as lodash from 'lodash';
import { OAuthService } from './../../services/o-auth';
import { Club } from './../../models/club';
import { ActivatedRoute } from '@angular/router';


@Component({
    templateUrl: './tee.component.html'
})
export class TeeComponent implements OnInit {
    public clubId: String;
    public club: Club;
    
    public courseId: string;
    public tees: Array<any>;
    public holesLast: Array<any>;
    public selectedTeeKey: any;
    public holesFirst: Array<any>;
    public form: FormGroup;
    public isEdit: boolean;
    public selectedTee: any;
    public holesCount: number;
    
    constructor(private fireDatabase: AngularFireDatabase, private apiService: ApiService,
        private oAuthService: OAuthService, private route: ActivatedRoute) {
        // this.club = this.oAuthService.getClub();
        this.isEdit = false;
        this.selectedTee = {
            name: '',
            color: '',
            $key: ''
        }

    }


    ngOnInit() {

        this.courseId = this.route.snapshot.paramMap.get('id');
        this.clubId = this.route.snapshot.paramMap.get('club');
        this.initData();

    }
    initData() {
        // console.log(this.club)
        this.apiService.object(`/users/${this.clubId }`)
            .then(club => {
                this.club = club;
                // this.oAuthService.setClub(this.club)
                if (this.club.courses) {
                    this.tees = [];

                    let count = 0;
                    lodash.forEach(this.club.courses, (item: any, key) => {
                        if (this.courseId === key) {
                            lodash.forEach(item.tees, (tee: any, key1) => {
                                this.tees.push({
                                    name: tee.name,
                                    color: tee.color,
                                    $key: key1,
                                    holes: item.holes
                                    
                                });
                                if (count === 0) {
                                    this.teeDetail(this.tees[0].$key, this.tees[0])
                                    // this.teeClick(this.tees[0])
                                }
                                count++;
                            });
                        }
                    });
                    // console.log(this.tees)
                }
            });

    }
    public getType(event) {
        // console.log(event);

    }
    public teeClick(tee) {
        this.selectedTee = tee;
        // console.log(this.selectedTee)

        $('#myTeeModal').modal('show');

    }
    public teeDetail(key,tee) {
        this.holesFirst = [];
        this.holesCount = tee.holes
        
        this.holesLast = [];
        this.selectedTeeKey = key;

        let count = 0;
        const fireObject = this.fireDatabase.object(`/courses/${this.club.$key}/${this.courseId}/${key}`)
            .subscribe(result => {

                // console.log(result)



                lodash.forEach(result, (item) => {
                    item.hole = count + 1;

                    if (count <= 8) {
                        this.holesFirst.push(item)

                    } else {
                        this.holesLast.push(item)

                    }

                    count++;

                });
                fireObject.unsubscribe();

            })
    }

    public edit() {
        this.isEdit = true
    }
    public save() {
        if (this.holesCount == 9) {
            var l = -1

            for (l = 0; l < this.holesFirst.length; l++) {
                var element = this.holesFirst[l];
                if (element.par == null || element.yards == null || element.stroke == null) {
                    element.isError = true
                    this.holesFirst[l] = element
                    break
                } else {
                    if (element.par == '' || element.yards == '' || element.stroke == '') {
                        element.isError = true
                        this.holesFirst[l] = element
                        break
                    } else {
                        element.isError = false
                        this.holesFirst[l] = element
                    }
                }
            }
            if (l != this.holesFirst.length && l > -1) {
                alert('Please enter all the fields')
            } else {
                this.updateDatabase()
            }
        }
        if (this.holesCount == 18) {
            var k = -1

            for (k = 0; k < this.holesFirst.length; k++) {
                var element = this.holesFirst[k];
                if (element.par == null || element.yards == null || element.stroke == null) {
                    element.isError = true
                    this.holesFirst[k] = element
                    break

                } else {
                    if (element.par == '' || element.yards == '' || element.stroke == '') {
                        element.isError = true
                        this.holesFirst[k] = element
                        break
                    } else {
                        element.isError = false
                        this.holesFirst[k] = element
                    }
                }
            }

            var m = -1

            for (m = 0; m < this.holesLast.length; m++) {
                var element = this.holesLast[m];
                if (element.par == null || element.yards == null || element.stroke == null) {
                    element.isError = true
                    this.holesLast[m] = element
                    break
                } else {
                    if (element.par == '' || element.yards == '' || element.stroke == '') {
                        element.isError = true
                        this.holesLast[m] = element
                        break
                    } else {
                        element.isError = false
                        this.holesLast[m] = element
                    }
                }
            }
            if ((k != this.holesFirst.length && k > -1) || (m != this.holesLast.length && m > -1)) {
                alert('Please enter all the fields')
            } else {
                this.updateDatabase()
            }
        }
    }

    private updateDatabase() {
        let holes = [];
        lodash.forEach(this.holesFirst, (item) => {
            delete item.hole;
            holes.push(item)
        })
        lodash.forEach(this.holesLast, (item) => {
            delete item.hole;

            holes.push(item)
        })

        // console.log(holes)
        this.fireDatabase.database.ref(`/courses/${this.club.$key}/${this.courseId}/${this.selectedTeeKey}`)
            .set(holes)
            .then(postResult => {

                this.isEdit = false
            })
            .catch(error => {
                // console.log(error);
            });
    }
    public updateTee() {
        let teeKey = this.selectedTee.$key;
        delete this.selectedTee.$key;
        // console.log(this.selectedTee)
        this.fireDatabase.database.ref(`/users/${this.club.$key}/courses/${this.courseId}/tees/${teeKey}/`)
            .set(this.selectedTee)
            .then(postResult => {
                this.initData();

                $('#myTeeModal').modal('hide');

            })
            .catch(error => {
                // console.log(error);
            });
    }
}
